import p1 from '../Assets/All Projects/akshoy kumar dutta sarani.jpg';
import p2 from '../Assets/All Projects/Raja nabakrisna Street final copy.jpg';
import p3 from '../Assets/All Projects/Hari Ghoshel edit glass.jpg';

const Bprojects = [
    {
        title: "Urban Heights",
        location: "Akshoy Kumar Dutta Sarani",
        image: p1
    },
    {
        title: "Riverside Residences",
        location: "Raja nabakrisna Street",
        image: p2
    },
    {
        title: "The Metropolitan",
        location: "Hari Ghoshel Street",
        image: p3
    }
];


export default Bprojects;